<template>
  <div class="shop-info-container" v-show="showzg">
    <!-- 1.店铺Logo + 店铺名 -->
    <!-- <div class="shop-header">
      <img class="shop-logo" :src="shopInfo.logo" alt="店铺logo" />
      <div class="shop-name">{{ shopInfo.name }}</div>
    </div> -->

    <!-- 2.店铺体验评分 -->
    <!-- <div class="rate-card">
      <div class="rate-title">店铺体验评分</div>
      <div class="rate-item" v-for="(item, idx) in rateList" :key="idx">
        <span class="rate-label">{{ item.label }}</span>
        <div class="star-box">
          <span
            class="star"
            v-for="s in 5"
            :key="s"
            :class="{ active: s <= item.score }"
          >★</span>
        </div>
      </div>
    </div> -->
    <!-- 
    3.资质证照按钮
    <div class="cert-card">
      <button class="cert-btn" @click="openModal">查看资质证照</button>
    </div> -->

    <!-- 验证码弹窗 -->

    <div class="modal">

      <div v-if="!verifySuccess">
        <h3 class="modal-title">请输入验证码查看店铺资质证照</h3>


        <div style="display: flex;">
          <el-input v-model="inputCode" class="input-code" placeholder="请输入验证码" @input="handleInput" />
          <h3 style="margin-left: 20px;" class="box"> {{ rightCode }}</h3>
        </div>


        <div class="tip-text" v-if="showError">验证码不正确，请重新输入</div>






      </div>

      <!-- 验证成功展示营业执照 -->
      <div class="license-box" v-if="verifySuccess">
        <p style="margin: 15px 0 8px; font-size:14px;">营业执照：</p>
        <a href="/static/image/yyzz.png" target="\_blank">
          <img @click="" class="license-img" src="/static/image/yyzz.png" alt="营业执照" />
        </a>
      </div>
      <div class="modal-btns">
        <button v-if="!verifySuccess" class="confirm" @click="checkCode">确认</button>
        <el-button class="close" @click="closeModal">关闭</el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ShopInfo',
  data() {
    return {
      // 店铺基础信息
      shopInfo: {
        logo: '/shop-logo.png',
        name: '荣创优选旗舰店'
      },

      props: {
        showzg: {
          type:Boolean,
          default:false
        },
      },
      // 评分配置 分数范围1~5
      rateList: [
        { label: '货品质量', score: 4 },
        { label: '物流速度', score: 3 },
        { label: '服务保障', score: 5 }
      ],
      licenseImg: '/business-license.jpg',

      rightCode: '123456',

      // 弹窗状态
      showModal: false,
      inputCode: '',
      showError: false,
      verifySuccess: false,
      showzg: true,

    }
  },


  mounted() {
    // 页面打开自动生成4位验证码
    this.showzg=false;
    this.rightCode = Math.floor(Math.random()* 10000).toString().padStart(4, '0');

  },

  methods: {

    handleInput() {
      this.showError = false;
    },
    openModal() {
      this.showzg=true;
      this.showModal = true
      this.inputCode = ''
      this.showError = false
      this.verifySuccess = false
    },
    closeModal() {
      this.showModal = false
      this.showzg = false;
    },
    checkCode() {
      console.log(2)
      const code = this.inputCode.trim()

      if (code === this.rightCode) {
        this.showError = false
        this.verifySuccess = true
      } else {
        this.showError = true
        this.verifySuccess = false
      }
    },



  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.shop-info-container {
  position: fixed;
  top: 150px;
  left:300px;
  /* 距离顶部 */
  width: 500px;
  background-color: #f5f7fa;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  z-index: 99999;
}

/* 店铺头部 */
.shop-header {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 15px;
}

.shop-logo {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #eee;
}

/* 评分卡片 */
.rate-card {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 15px;
}

.rate-title {
  font-size: 16px;
  margin-bottom: 16px;
  color: #333;
}

.rate-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f1f1f1;
}

.rate-item:last-child {
  border-bottom: none;
}

.star-box {
  display: flex;
  gap: 4px;
}


/* 资质区域 */
.cert-card {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}

.cert-btn {
  padding: 10px 24px;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
}

.cert-btn:hover {
  background: #1d4ed8;
}

/* 弹窗遮罩 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal {

  max-width: 800px;
  background: #fff;
  border-radius: 10px;
  padding: 24px;
}

.modal-title {
  font-size: 17px;
  margin-bottom: 16px;
}

.input-code {
  width: 60%;
  padding: 12px;
  font-size: 15px;
}

.modal-btns {
  display: flex;
  gap: 10px;
}

.confirm,
.close {
  flex: 1;
  width: 150px;
  padding: 11px;
  border-radius: 6px;
  border: none;
  font-size: 15px;
  cursor: pointer;

}

.confirm {
  background: #2563eb;
  color: #fff;
}

.close {

  background: #eee;
}


.tip-text {
  margin: 10px 0;
  color: #f03838;
  font-size: 14px;
}

.license-box {
  margin-top: 15px;
}

.license-img {
  width: 100%;
  border: 1px solid #eee;
  border-radius: 6px;
}

.box {
  border: 1px solid #eee;
  border-radius: 6px;
  background-color: #eee;
  font-size: 24px;
  height: 50px;
  line-height: 50px;
  width: 100px;
  padding-left: 10px;


}
</style>



// WEBPACK FOOTER //
// src/new/stroreinfo.vue